import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  LoginRequest,
  LoginResponse,
  VerifyLoginOtpRequest,
  VerifyLoginOtpResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  ResendOtpResponse
} from '../types';

const { AUTH } = API_ENDPOINTS;

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>(AUTH.LOGIN, data),

  verifyLoginOtp: (data: VerifyLoginOtpRequest) =>
    apiClient.post<VerifyLoginOtpResponse>(AUTH.VERIFY_LOGIN_OTP, data),

  forgotPassword: (data: ForgotPasswordRequest) =>
    apiClient.post(AUTH.FORGOT_PASSWORD, data),

  resetPassword: (data: ResetPasswordRequest) =>
    apiClient.post(AUTH.RESET_PASSWORD, data),

  fetchMyPermissions: () =>
    apiClient.get<{ roles: string[]; permissions: string[] }>(AUTH.PERMISSIONS),

  resendLoginOtp: (data: { email: string }) =>
    apiClient.post<ResendOtpResponse>(AUTH.RESEND_OTP, data),

  logout: () => apiClient.post(AUTH.LOGOUT),

  refresh: () => apiClient.post<{ token: string }>(AUTH.REFRESH)
};
